"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userPermissions = void 0;
var userPermissions = exports.userPermissions = {
  submitBlockTrade: 'SubmitBlockTrade',
  requestTransferFunds: 'RequestTransferFunds',
  trading: 'Trading',
  deposit: 'Deposit',
  withdraw: 'Withdraw',
  superUser: 'SUPERUSER',
  operator: 'Operator'
};